// src/pages/tpo/AddDrive.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api";
import "../../css/AddDrive.css";

const AddDrive = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    company: "",
    role: "",
    package: "",
    location: "",
    deadline: "",
    eligibilityCriteria: "",
    jobDescription: "",
    rounds: "",
    contactEmail: "",
    additionalNotes: "",
    minCGPA: "",
    allowedBranches: "",
  });
  const [allBranches, setAllBranches] = useState(true);
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const ALL_BRANCH_LIST = ["CSE", "CSE-AI", "CSE-DS", "IT", "ECE", "EN", "ME", "CE"];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleBranch = (branch) => {
    const current = formData.allowedBranches.split(",").map(b => b.trim().toUpperCase()).filter(Boolean);
    let updated;
    if (current.includes(branch)) {
      updated = current.filter(b => b !== branch);
    } else {
      updated = [...current, branch];
    }
    setFormData({ ...formData, allowedBranches: updated.join(", ") });
    if (updated.length > 0) setAllBranches(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      const drivePayload = {
        ...formData,
        minCGPA: formData.minCGPA ? parseFloat(formData.minCGPA) : 0,
        allowedBranches: allBranches
          ? []
          : formData.allowedBranches.split(",").map(b => b.trim().toUpperCase()).filter(Boolean)
      };

      await API.post("/drives", drivePayload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Drive Created Successfully ✅");
      navigate("/tpo");
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert(err.response?.data?.message || "Error creating drive ❌");
    }

    setLoading(false);
  };

  const formFields = [
    { name: "company", label: "Company Name", type: "text", icon: "🏢", required: true },
    { name: "role", label: "Job Role", type: "text", icon: "💼", required: true },
    { name: "package", label: "Package (e.g. 12 LPA)", type: "text", icon: "💰", required: true },
    { name: "location", label: "Location", type: "text", icon: "📍", required: true },
    { name: "deadline", label: "Application Deadline", type: "date", icon: "📅", required: true },
    { name: "minCGPA", label: "Minimum CGPA Required", type: "number", icon: "📊" },
    { name: "allowedBranches", label: "Allowed Branches", type: "text", icon: "🎓", placeholder: "CSE, IT, ECE..." },
    { name: "eligibilityCriteria", label: "Other Eligibility Notes", type: "text", icon: "⚖️" },
    { name: "jobDescription", label: "Job Description", type: "textarea", icon: "📝", rows: 3 },
    { name: "rounds", label: "Selection Rounds", type: "text", icon: "🎯" },
    { name: "contactEmail", label: "Contact Email", type: "email", icon: "📧" },
    { name: "additionalNotes", label: "Additional Notes", type: "textarea", icon: "📌", rows: 2 },
  ];

  return (
    <div className="add-drive-container">
      <div className="add-drive-card">
        <div className="add-drive-header">
          <div className="add-drive-icon">🚀</div>
          <h2>Create New <span>Drive</span></h2>
          <p>Configure placement details for upcoming recruitment</p>
        </div>

        <form className="add-drive-form" onSubmit={handleSubmit}>
          <div className="add-drive-grid">
            {formFields.map((field, index) => (
              <div
                key={field.name}
                className={`add-drive-field ${field.type === "textarea" ? "full-width" : ""} ${focusedField === field.name ? "focused" : ""
                  }`}
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <label className="add-drive-label">
                  <span className="add-drive-label-icon">{field.icon}</span>
                  {field.label}
                  {field.required && <span className="required">*</span>}
                </label>

                {field.name === "allowedBranches" ? (
                  <div className="branch-selection-container">
                    <div className="branch-toggle-row">
                      <label className="all-branches-toggle">
                        <input
                          type="checkbox"
                          checked={allBranches}
                          onChange={(e) => {
                            setAllBranches(e.target.checked);
                            if (e.target.checked) setFormData({ ...formData, allowedBranches: "" });
                          }}
                        />
                        <span className="toggle-text">Allow All Branches</span>
                      </label>
                    </div>
                    {!allBranches && (
                      <>
                        <input
                          type="text"
                          name="allowedBranches"
                          value={formData.allowedBranches}
                          onChange={handleChange}
                          onFocus={() => setFocusedField("allowedBranches")}
                          onBlur={() => setFocusedField(null)}
                          placeholder="Manually enter or select below..."
                          className="add-drive-input"
                        />
                        <div className="branch-tags">
                          {ALL_BRANCH_LIST.map(branch => (
                            <span
                              key={branch}
                              className={`branch-tag ${formData.allowedBranches.toUpperCase().includes(branch) ? 'active' : ''}`}
                              onClick={() => toggleBranch(branch)}
                            >
                              {branch}
                            </span>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                ) : field.type === "textarea" ? (
                  <textarea
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    onFocus={() => setFocusedField(field.name)}
                    onBlur={() => setFocusedField(null)}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                    rows={field.rows}
                    required={field.required}
                    className="add-drive-textarea"
                  />
                ) : (
                  <input
                    type={field.type}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    onFocus={() => setFocusedField(field.name)}
                    onBlur={() => setFocusedField(null)}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                    required={field.required}
                    className="add-drive-input"
                  />
                )}
              </div>
            ))}
          </div>

          <div className="add-drive-actions">
            <button
              type="button"
              className="add-drive-btn-secondary"
              onClick={() => navigate("/tpo")}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`add-drive-btn-primary ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Creating...
                </>
              ) : (
                <>
                  <span>✨</span>
                  Create Drive
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDrive;
